export default __webpack_public_path__ + "static/media/search-movies-page-light.68c67366.png";